import gql from 'graphql-tag'

export const externalCoursesFragment = gql`
  fragment ExternalCoursesFragment on ExternalCourse {
    id
    name
    code
    institution
    additionalCode
    hours
    startDate
    endDate
    participantsCount
    progress {
      finish
      inProgress
      pending
    }
    progressEvaluations {
      reproved
      approved
      total
    }
  }
`
